import { createClient } from '@supabase/supabase-js';

// We use Environment Variables so your keys stay safe (explained in Phase 3)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_KEY || "";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);